import Vue from "vue";
import VueRouter from "vue-router";
import { get } from "lodash";
import store from "../store";
import { USER } from "../store/actions";

Vue.use(VueRouter);

const pageTitleBase = "The Dinner Debate";

const routes = [
  {
    path: "/",
    redirect: "/recipes"
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
    meta: {
      title: "Register"
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: {
      title: "Login"
    }
  },
  {
    path: "/recipes",
    name: "Recipes",
    component: () => import("../views/Recipes/RecipeList.vue"),
    meta: {
      title: "Recipes"
    }
  },
  {
    path: "/recipes/:categoryKey/:key",
    name: "RecipeView",
    component: () => import("../views/Recipes/RecipeView.vue"),
    meta: {
      title: "Recipe View"
    }
  },
  {
    path: "/recipes/:categoryKey",
    name: "RecipeNew",
    component: () => import("../views/Recipes/RecipeDetail.vue"),
    meta: {
      title: "Add New Recipe"
    }
  },
  {
    path: "/recipes/:categoryKey/:key/edit",
    name: "RecipeDetail",
    component: () => import("../views/Recipes/RecipeDetail.vue"),
    meta: {
      title: "Recipe Detail"
    }
  }
];

const router = new VueRouter({
  mode: 'history', //removes # from url
  routes
});

const UNPROTECTED_ROUTES = ["Recipes", "RecipeView", "Login", "Register"];

router.beforeEach(async (to, from, next) => {
  const toRouteName = to.name;
  const isAuthenticated = get(store, "state.user.isAuthenticated", false);

  // User is not logged in and attempted to navigate to an authenticated route
  if (!isAuthenticated && !UNPROTECTED_ROUTES.includes(toRouteName)) {
    // Let's make sure they don't have a session we don't know about
    try {
      await store.dispatch(`user/${USER.SET_PROFILE}`);
      // On second thought, they actually were authenticated!
      next();
    } catch (e) {
      next({ name: "Recipes" });
    }
    return;
  }

  if ("Login" === toRouteName && isAuthenticated) {
    // User is logged in, why try to go to Login?
    next({ name: "Recipes" });
    return;
  }

  document.title = to.meta.title
    ? `${to.meta.title} | ${pageTitleBase}`
    : pageTitleBase;

  next();
});

export default router;

export { UNPROTECTED_ROUTES, pageTitleBase };
